export default "__VITE_ASSET__4ad2e492__"